const workOrderRegex = /^[A-Z]{2}-\d+-\d+$/;
const employeeIdRegex = /^[A-Z]{2}\d{4}$/;

export const onBarcodeScanHelper = ({
  barcode = "",
  options = [],
  users = [],
  addworkOrder = () => {},
  setValue = () => {},
}) => {
  const workOrderMatch = workOrderRegex.test(barcode);
  const employeeIdMatch = employeeIdRegex.test(barcode);

  if (employeeIdMatch) {
    const user = users?.find((u) => u?.employeeId === barcode);
    if (user?.id) setValue("userId", user.id);
    return;
  }

  if (!workOrderMatch) return;

  const route = options?.find(({ label }) => label === barcode);
  if (route?.id) addworkOrder({ routeId: route.id });
  return;
};

export const handleBarcodeHelper = ({
  routeId,
  append = () => {},
  getValues = () => {},
  setValue = () => {},
  options = [],
}) => {
  const route = options?.find((wo) => wo.id === routeId);

  if (!route.id) return;

  return handleAddHelper({
    defaultValues: { routeId },
    append,
    getValues,
    setValue,
    options,
  });
};

export const handleAddHelper = ({
  defaultValues = {},
  append = () => {},
  getValues = () => {},
  setValue = () => {},
  options = [],
}) => {
  const id = defaultValues?.routeId || null;
  const route = options?.find((wo) => wo.id === id);
  const available = route?.availableToBox || 0;

  const items = getValues("routes");

  const duplicate = items?.map(({ routeId }) => routeId).includes(id);
  if (duplicate) return;

  const quantity = available - route?.boxed > 0 ? available - route?.boxed : 0;

  const partWeight = route?.part?.weight || 0;
  const preRound = Number(quantity) * Number(partWeight);
  const weight = Math.round(preRound * 100) / 100;

  const value = {
    routeId: id,
    quantity,
    weight,
    ...defaultValues,
  };
  append(value);

  const boxWeight = getValues("weight") || 0;
  const newBoxWeight = Math.round(boxWeight + weight * 100) / 100;
  setValue("weight", newBoxWeight);
};
